import classNames from "classnames";
import SimpleBar from "simplebar-react";
import { Fragment, useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { useSelector } from "react-redux";

import MenuSidebar from "./MenuSidebar/MenuSidebar";
import Icon from "../../components/Icon/Icon";
import UserAvatar from "./../../components/UserAvatar/UserAvatar";
import useMenuData from "./MenuSidebar/useMenuData";
import { UserHeaderContent } from "../Header/UserHeader/UserHeader";
import { convertRoleToPath } from "../../utils";

const Sidebar = ({
  fixed,
  theme,
  className,
  sidebarToggle,
  mobileView,
  currentMenuTab,
}) => {
  const classes = classNames({
    "nk-sidebar-main": true,
    "nk-sidebar-fixed": fixed,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
    [`${className}`]: className,
  });

  return (
    <div className={classes}>
      <SimpleBar className="nk-sidebar-inner">
        <MenuSidebar
          currentMenuTab={currentMenuTab}
          sidebarToggle={sidebarToggle}
          mobileView={mobileView}
        />
      </SimpleBar>
    </div>
  );
};
export default Sidebar;

export const LeftPanel = ({ theme, setCurrentMenuTab, setVisibility }) => {
  const auth = useSelector((state) => state.auth);

  const [menuTab, setMenuTab] = useState("داشبورد");
  const [isOpen, setOpen] = useState(false);

  const { pathname } = useLocation();

  const menu = useMenuData();

  const checkMenuUrl = (data) => {
    for (const node of data.subMenu) {
      if (node.link === pathname) {
        return node;
      } else {
        const newNode = node.subMenu ? checkMenuUrl(node) : undefined;
        if (newNode) return newNode;
      }
    }
  };

  useEffect(() => {
    let found;
    menu.forEach((item) => {
      found = checkMenuUrl(item);
      if (found !== undefined) {
        setMenuTab(item.heading);
      }
    });
  }, [pathname, menu]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setCurrentMenuTab(menuTab);
  }, [menuTab, setCurrentMenuTab]);

  const appSidebarClass = classNames({
    "nk-sidebar-bar": true,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
  });

  return (
    <div className={appSidebarClass}>
      <div className="nk-apps-brand">
        <Link to={`/${convertRoleToPath(auth?.role)}`} className="logo-link">
          <img
            className="logo-light logo-img"
            src="/assets/images/logo-small.png"
            alt="logo"
          />
          <img
            className="logo-dark logo-img"
            src="/assets/images/logo-dark-small.png"
            alt="logo-dark"
          />
        </Link>
      </div>
      <div className="nk-sidebar-element">
        <div className="nk-sidebar-body">
          <SimpleBar className="nk-sidebar-content">
            <div className="nk-sidebar-menu">
              <ul className="nk-menu apps-menu">
                {menu.map((item, index) => (
                  <Fragment key={index}>
                    <li
                      className={`nk-menu-item ${
                        item.heading === menuTab ? "active" : ""
                      }`}
                      key={index}
                      id={"page" + index}
                    >
                      <a
                        href="#link"
                        className="nk-menu-link nk-menu-switch"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setMenuTab(item.heading);
                        }}
                      >
                        <span className="nk-menu-icon">
                          <Icon name={item.icon} />
                        </span>
                      </a>
                    </li>
                  </Fragment>
                ))}
              </ul>
            </div>
            <div className="nk-sidebar-footer">
              <ul className="nk-menu nk-menu-md apps-menu">
                <li
                  className="nk-menu-item"
                  id="settingsTooltip"
                  onClick={() => setVisibility(false)}
                >
                  <Link
                    to={`/${convertRoleToPath(auth?.role)}/profile`}
                    className="nk-menu-link"
                  >
                    <span className="nk-menu-icon">
                      <Icon name="setting" />
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </SimpleBar>
          <Dropdown
            isOpen={isOpen}
            toggle={() => setOpen(!isOpen)}
            className="nk-sidebar-profile nk-sidebar-profile-fixed"
            direction="right"
          >
            <DropdownToggle
              tag="a"
              href="#toggle"
              className="dropdown-toggle"
              onClick={(ev) => {
                ev.preventDefault();
              }}
            >
              <UserAvatar icon="user-alt" />
            </DropdownToggle>
            <DropdownMenu
              right
              className="dropdown-menu-md ml-4"
              style={{ right: "unset" }}
            >
              <UserHeaderContent
                toggle={() => {
                  setOpen(false);
                  setVisibility(false);
                }}
              />
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export const Toggle = ({ className, click, icon }) => {
  return (
    <a
      href="#toggle"
      className={className ? className : ""}
      onClick={(ev) => {
        ev.preventDefault();
        click(ev);
      }}
    >
      <Icon name={icon} />
    </a>
  );
};
